import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../utils/handleError';
import { VouchersApi } from '../../_helpers/service';
import Notice from '../../utils/Notice';
import i18next from 'i18next';
import Dict from '../../utils/Dict';

/**
 * Constants
 */

export const vouchersModule = 'vouchers';
const LOADING = `${vouchersModule}/LOADING`;
const SET_DATA = `${vouchersModule}/SET_DATA`;
const CLEAR_STATE = `${vouchersModule}/CLEAR_STATE`;
const LOADING_SAVE = `${vouchersModule}/LOADING_SAVE`;

/**
 * Reducer
 */

const initialState = {
  loading: false,
  loadingSave: false,
  data: [],
};

export default createReducer(initialState, {
  [SET_DATA]: (state, action) => {
    state.data = action.payload;
  },
  [LOADING]: (state, action) => {
    state.loading = action.payload;
  },
  [LOADING_SAVE]: (state, action) => {
    state.loadingSave = action.payload;
  },
  [CLEAR_STATE]: () => initialState
});

/**
 * Actions
 */

export const loadData = ({filter}) => async dispatch => {
  try {
    dispatch({ type: LOADING, payload: true });
    const {data} = await VouchersApi.loadData(JSON.stringify(filter));
    if (data.status === 'SUCCESS') {
      const dictKato = await Dict.itemsObject('60');
      for (let row of data.result) {
        row.queuedLocation = dictKato[row.queuedRegion] || {};
      }
      dispatch({ type: SET_DATA, payload: data.result });
    } else {
      handleError(data, i18next.t('vouchers_errorLoadTable'));
    }
  } catch (error) {
    handleError(error, i18next.t('vouchers_errorLoadTable'));
  } finally {
    dispatch({ type: LOADING, payload: false });
  }
};

export const clearState = () => ({ type: CLEAR_STATE });

export const setVoucher = ({values, close}) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOADING_SAVE, payload: true });
    const state = getState()[vouchersModule];
    const stateCopy = JSON.parse(JSON.stringify(state.data));
    const {data} = await VouchersApi.saveVoucher(values);
    if (data.status === 'SUCCESS') {
      const dictKato = await Dict.itemsObject('60');
      data.result.queuedLocation = dictKato[data.result.queuedRegion] || {};
      const index = stateCopy.findIndex((el) => el.queuedRegion === values.queuedRegion);
      if (index !== -1) {
        stateCopy[index] = data.result
        dispatch({ type: SET_DATA, payload: stateCopy });
      } else {
        stateCopy.unshift(data.result)
        dispatch({ type: SET_DATA, payload: stateCopy });
      }
      Notice.success(i18next.t('vouchers_saveFormSuccess'))
    }
    close()
  } catch (error) {
    const responseData = error.response?.data || {};
    const errorCode = responseData?.errors?.[0]?.code;

    if (errorCode === "error.invalid_voucher_amount") {
      const match = responseData.message?.match(/available\s*=\s*(\d+)/);
      const available = match ? Number(match[1]) : 0;

      Notice.error(
        i18next.t("vouchers_errorSaveVoucherAmount", { count: available })
      );
    } else {
      handleError(error, i18next.t('vouchers_saveFormError'));
    }
  } finally {
    dispatch({ type: LOADING_SAVE, payload: false });
  }
}
